"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useLocale } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { SearchArticle } from "./useSearchPage";
interface ArticleResultCardProps {
  article: SearchArticle;
  featured?: boolean;
}
function formatDate(dateStr: string | null, locale: string): string {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}
export function ArticleResultCard(t0) {
  const $ = _c(55);
  const {
    article,
    featured: t1
  } = t0;
  const featured = t1 === undefined ? false : t1;
  const locale = useLocale();
  const nav = useNavigation();
  let t2;
  if ($[0] !== article || $[1] !== nav) {
    t2 = nav.post(article);
    $[0] = article;
    $[1] = nav;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const href = t2;
  let t3;
  if ($[3] !== article.publishedAt || $[4] !== locale) {
    t3 = formatDate(article.publishedAt, locale);
    $[3] = article.publishedAt;
    $[4] = locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const dateText = t3;
  const categoryTitle = article.categories[0]?.title;
  if (featured) {
    let t4;
    if ($[6] !== article.heroImage || $[7] !== article.title) {
      t4 = article.heroImage?.url ? <Image src={article.heroImage.url} alt={article.heroImage.alt || article.title} fill={true} sizes="(min-width: 768px) 50vw, 100vw" className="object-cover" unoptimized={true} /> : null;
      $[6] = article.heroImage;
      $[7] = article.title;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t4) {
      t5 = <div className="relative aspect-video md:aspect-auto md:h-full bg-muted">{t4}</div>;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== categoryTitle) {
      t6 = categoryTitle && <div className="text-xs uppercase tracking-wider text-primary font-semibold">{categoryTitle}</div>;
      $[11] = categoryTitle;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== article.title) {
      t7 = <h3 className="text-xl font-bold text-foreground line-clamp-3 group-hover:text-primary transition-colors">{article.title}</h3>;
      $[13] = article.title;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== article.excerpt) {
      t8 = article.excerpt && <p className="text-sm text-muted-foreground line-clamp-3">{article.excerpt}</p>;
      $[15] = article.excerpt;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== dateText) {
      t9 = dateText && <div className="text-xs text-muted-foreground mt-auto">{dateText}</div>;
      $[17] = dateText;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
      t10 = <div className="p-5 flex flex-col gap-2">{t6}{t7}{t8}{t9}</div>;
      $[19] = t6;
      $[20] = t7;
      $[21] = t8;
      $[22] = t9;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    let t11;
    if ($[24] !== t10 || $[25] !== t5) {
      t11 = <div className="grid md:grid-cols-2 gap-0">{t5}{t10}</div>;
      $[24] = t10;
      $[25] = t5;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    let t12;
    if ($[27] !== href || $[28] !== t11) {
      t12 = <Link prefetch={false} href={href} className="group block border border-border rounded-lg overflow-hidden bg-card hover:bg-muted/40 transition">{t11}</Link>;
      $[27] = href;
      $[28] = t11;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    return t12;
  }
  let t4;
  if ($[30] !== article.heroImage || $[31] !== article.title) {
    t4 = article.heroImage?.url ? <Image src={article.heroImage.url} alt={article.heroImage.alt || article.title} fill={true} sizes="(min-width: 640px) 128px, 100vw" className="object-cover" unoptimized={true} /> : null;
    $[30] = article.heroImage;
    $[31] = article.title;
    $[32] = t4;
  } else {
    t4 = $[32];
  }
  let t5;
  if ($[33] !== t4) {
    t5 = <div className="relative w-full sm:w-32 aspect-video sm:aspect-square sm:h-20 shrink-0 bg-muted rounded overflow-hidden">{t4}</div>;
    $[33] = t4;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  let t6;
  if ($[35] !== article.title) {
    t6 = <h3 className="text-base font-semibold text-foreground line-clamp-2 group-hover:text-primary transition-colors">{article.title}</h3>;
    $[35] = article.title;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[37] !== categoryTitle) {
    t7 = categoryTitle && <span className="font-medium text-primary/80">{categoryTitle}</span>;
    $[37] = categoryTitle;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  let t8;
  if ($[39] !== categoryTitle || $[40] !== dateText) {
    t8 = categoryTitle && dateText && <span aria-hidden={true}>·</span>;
    $[39] = categoryTitle;
    $[40] = dateText;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  let t9;
  if ($[42] !== dateText) {
    t9 = dateText && <span>{dateText}</span>;
    $[42] = dateText;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  let t10;
  if ($[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
    t10 = <div className="mt-1 text-xs text-muted-foreground flex items-center gap-2">{t7}{t8}{t9}</div>;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = t10;
  } else {
    t10 = $[47];
  }
  let t11;
  if ($[48] !== t10 || $[49] !== t6) {
    t11 = <div className="min-w-0 flex-1">{t6}{t10}</div>;
    $[48] = t10;
    $[49] = t6;
    $[50] = t11;
  } else {
    t11 = $[50];
  }
  let t12;
  if ($[51] !== href || $[52] !== t11 || $[53] !== t5) {
    t12 = <Link prefetch={false} href={href} className="group flex flex-col sm:flex-row gap-4 py-4 border-b border-border last:border-b-0 hover:bg-muted/40 transition px-2 -mx-2 rounded">{t5}{t11}</Link>;
    $[51] = href;
    $[52] = t11;
    $[53] = t5;
    $[54] = t12;
  } else {
    t12 = $[54];
  }
  return t12;
}